'use client';

import { createContext, useContext, useEffect, useRef, useState } from "react";
import { usePathname, useSearchParams } from "next/navigation";

interface RefContextType {
    currentUrl: string;
    prevUrl: string;
    setVirtualUrl: (url: string) => void; // state 기반 이동에서 사용
}

export const RefContext = createContext<RefContextType>({
    currentUrl: "",
    prevUrl: "",
    setVirtualUrl: () => {}
});

export function RefProvider({ children }: { children: React.ReactNode }) {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    const [currentUrl, setCurrentUrl] = useState(
        pathname + (searchParams.toString() ? "?" + searchParams.toString() : "")
    );
    const [prevUrl, setPrevUrl] = useState("");

    const isVirtualRef = useRef(false);

    // state 기반 이동 시 호출되는 함수
    function setVirtualUrl(url: string) {
        isVirtualRef.current = true;

        // 뒤로가기 히스토리 삽입
        // const absoluteUrl = new URL(url, window.location.origin).toString();
        if (currentUrl !== url) {
            // window.history.pushState({}, "", absoluteUrl);
            window.history.pushState({}, "", url);
        }

        setCurrentUrl(url);
    }
    
    useEffect(() => {
        const realUrl = pathname + (searchParams.toString() ? `?${searchParams.toString()}` : "");

        // 여기서 `_` 파라미터 감지
        const hasCacheBuster = searchParams.has("_");

        if (hasCacheBuster) {
            // 캐시버스터는 라우팅 업데이트 안 하도록 무시
            return;
        }

        if (!isVirtualRef.current) {
            // 일반적인 라우터 이동
            setPrevUrl(currentUrl);
            setCurrentUrl(realUrl);
        } else {
            // state 기반 이동
            setPrevUrl(currentUrl);
            isVirtualRef.current = false;
        }
    }, [pathname, searchParams]);

    
    // useEffect(() => {
    //     // ================================
    //     // History Debug Logger
    //     // ================================
    //     (function () {
    //         const historyLog: string[] = [];

    //         function logHistory(action: string, url: string) {
    //             historyLog.push(`${action}: ${url}`);
    //             console.log("=== HISTORY STACK (simulated) ===");
    //             historyLog.forEach((item, i) => console.log(i, item));
    //             console.log("=================================");
    //         }

    //         // pushState 
    //         const originalPush = window.history.pushState;
    //         window.history.pushState = function (...args) {
    //             const url = String(args[2] || "");
    //             logHistory("pushState", url);
    //             return originalPush.apply(window.history, args as any);
    //         };

    //         // replaceState 
    //         const originalReplace = window.history.replaceState;
    //         window.history.replaceState = function (...args) {
    //             const url = String(args[2] || "");
    //             logHistory("replaceState", url);
    //             return originalReplace.apply(window.history, args as any);
    //         };

    //         // popstate  (뒤로가기/앞으로가기)
    //         window.addEventListener("popstate", () => {
    //             logHistory("popstate (BACK/FORWARD)", window.location.href);
    //         });

    //         console.log("History debug logger enabled.");
    //     })();

    // }, []);




    return (
        <RefContext.Provider value={{ currentUrl, prevUrl, setVirtualUrl }}>
            {children}
        </RefContext.Provider>
    );
}
